<app-headerpicture> </app-headerpicture>

<div class="vl-region">
  <div class="vl-layout vl-layout--wide">
    <div class="vl-grid vl-grid--is-stacked">
      <div class="vl-col--9-12 vl-col--9-12--m vl-col--12-12--s vl-col--1-1--xs">
        <!-- Begin content -->
        <div class="vl-u-spacer content typography introduction">
          <p [innerHtml]="'WELKOM_TEKST' | translate"></p>
        </div>
        <button class="vl-button vl-u-float-right" (click)="startOnClick()">Naar mijn aanvraag</button>
        <!-- End content -->
      </div>
      <div class="vl-col--3-12 vl-col--3-12--m vl-col--12-12--s vl-col--1-1--xs">
        <!-- Begin Side navigation -->

        <!-- End Side navigation -->
      </div>
    </div>
  </div>
</div>
